export const GET_SECURITY_QUESTIONS_SUCCESS = "GET_SECURITY_QUESTIONS_SUCCESS";
export const GET_SECURITY_QUESTIONS_ERROR = "GET_SECURITY_QUESTIONS_ERROR";
